import { PROGRESS_BUTTON_STROKE_WIDTH, DEFAULT_SETTINGS } from './consts.js';

/** Рассчёт размеров контейнера и радиуса границ для отрисовки в нём svg */
var calcSettings = function (buttonRef) {
    var buttonObj = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
    if (buttonObj) {
        var buttonObjRect = buttonObj.getBoundingClientRect();
        return {
            width: buttonObjRect.width,
            height: buttonObjRect.height,
            startPos: buttonObj.offsetWidth / 2,
            strokeWidth: PROGRESS_BUTTON_STROKE_WIDTH,
            borderRadius: 12
        };
    }
    return DEFAULT_SETTINGS;
};
var calcPathDefinition = function (settings) { return "\n\tM ".concat(settings.startPos, " ").concat(settings.strokeWidth, " \n\tH").concat(settings.width - settings.borderRadius, "\n\ta").concat(settings.borderRadius, ",").concat(settings.borderRadius, " 0 0 1 ").concat(settings.borderRadius, ",").concat(settings.borderRadius, "\n\tV").concat(settings.height - settings.borderRadius, "\n\ta").concat(settings.borderRadius, ",").concat(settings.borderRadius, " 0 0 1 -").concat(settings.borderRadius, ",").concat(settings.borderRadius, "\n\tH").concat(settings.borderRadius + settings.strokeWidth, "\n\ta").concat(settings.borderRadius, ",").concat(settings.borderRadius, " 0 0 1 -").concat(settings.borderRadius, ",-").concat(settings.borderRadius, "\n\tV").concat(settings.borderRadius + settings.strokeWidth, "\n\ta").concat(settings.borderRadius, ",").concat(settings.borderRadius, " 0 0 1 ").concat(settings.borderRadius, ",-").concat(settings.borderRadius, "\n\tH ").concat(settings.startPos, "\n"); };
/**
 * проверяет является ли переданный объект оьектом ошибки
 *
 * @param err потенциальный объект ошибки
 */
var isErrorObject = function (err) {
    return !!err && typeof err === 'object' && Object.prototype.toString.call(err) === '[object Error]';
};

export { calcPathDefinition, calcSettings, isErrorObject };
